import { render, staticRenderFns } from "./grandShine.vue?vue&type=template&id=bc9405a2&scoped=true"
import script from "./grandShine.vue?vue&type=script&lang=js"
export * from "./grandShine.vue?vue&type=script&lang=js"
import style0 from "./grandShine.vue?vue&type=style&index=0&id=bc9405a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9405a2",
  null
  
)

export default component.exports